import type { CatalogItem } from '@/entities/catalog-item';

import { useForwardCatalog, useSpotCatalog } from '../api/queries';

type CatalogStatus = 'loading' | 'error' | 'fulfilled';

const getCatalogStatus = (query: {
  data?: CatalogItem[];
  isLoading: boolean;
  isError: boolean;
}): CatalogStatus => {
  if (query.isLoading) return 'loading';
  if (query.isError) return 'error';
  if (query.data === undefined) return 'loading';
  return 'fulfilled';
};

export const useCatalogData = (isForwardCurves: boolean) => {
  const spotQuery = useSpotCatalog();
  const forwardQuery = useForwardCatalog();

  const catalog = isForwardCurves ? forwardQuery.data : spotQuery.data;
  const status = getCatalogStatus(isForwardCurves ? forwardQuery : spotQuery);

  return { catalog, status };
};
